/* LAIIRA refinements script. */
(function () {
  /* 1. Back-to-top button: move it to the page root so it is always fixed to the browser window, never trapped inside the footer area. */
  function lift() {
    var t = document.querySelector('.lr-top');
    if (t && t.parentNode !== document.body) { document.body.appendChild(t); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lift);
  } else {
    lift();
  }
  window.addEventListener('load', lift);

  /* 2. Cursor ring hides over interface controls so nothing is ever hard to find or click. */
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!(window.matchMedia && window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches)) return;

  var tries = 0;
  var timer = setInterval(function () {
    var ring = document.querySelector('.lr-cur-ring');
    if (ring) {
      clearInterval(timer);
      document.addEventListener('mousemove', function (e) {
        var t = e.target;
        var ui = t && t.closest && t.closest('#header-group, dialog, theme-drawer, input, select, textarea, [role=dialog], quick-add-component, .quick-add__button, .cart-drawer');
        ring.classList.toggle('is-ui', !!ui);
      }, { passive: true });
    } else if (++tries > 40) {
      clearInterval(timer);
    }
  }, 100);
})();
